import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getDocs } from "firebase/firestore";

import {
  Button,
  Divider,
  Header,
  Segment,
  Grid,
  Icon,
  Popup,
} from "semantic-ui-react";

import { useMediaQuery } from "react-responsive";
import { closeModal } from "../../../app/common/modals/modalSlice";
import ModalWrapper from "../../../app/common/modals/modalWrapper";
import { Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import MyTextInput from "../../../app/common/form/MyTextInput";
import MyTextArea from "../../../app/common/form/MyTextArea";
import MySelectInput from "../../../app/common/form/MySelectInput";
import { toast } from "../../../../node_modules/react-toastify/dist/index";
import {
  dataFromSnapshot,
  fetchPartiesFromDb,
  updateTransFieldsInDb,
} from "../../../app/firestore/firestoreService";
import {
  convertFullName,
  safelyRoundNumber,
} from "../../../app/common/util/util";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { addFormsToTransaction } from "../../../app/firestore/firebaseService";

// import { values } from "lodash";

export default function ManagerEditClosingDisbursement({
  transaction,
  agent,
  brokerageDetails,
}) {
  const dispatch = useDispatch();
  const { forms } = useSelector((state) => state.doc);
  const { currentUserProfile } = useSelector((state) => state.profile);
  const { agentsForManagerActive } = useSelector((state) => state.profile);
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width:768px)" });
  const transactionId = transaction?.id;
  const [transactionParties, setTransactionParties] = useState([]);
  const [partiesLoaded, setPartiesLoaded] = useState(false);

  // currently must be manager logged in for this page
  useEffect(() => {
    let isMounted = true;

    async function loadTransactionParties() {
      if (!transactionId) {
        setPartiesLoaded(true);
        return;
      }

      setPartiesLoaded(false);
      try {
        const snapshot = await getDocs(fetchPartiesFromDb(transactionId));
        const parties = snapshot.docs.map((doc) => dataFromSnapshot(doc));
        if (isMounted) {
          setTransactionParties(parties);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        if (isMounted) {
          setPartiesLoaded(true);
        }
      }
    }

    loadTransactionParties();

    return () => {
      isMounted = false;
    };
  }, [transactionId]);

  if (!agentsForManagerActive || !partiesLoaded) {
    return <LoadingComponent />;
  }

  const agentProf = agentsForManagerActive?.agents?.filter(
    (ag) => ag.id === agent.id,
  );
  const agentProfile = agentProf ? agentProf[0] : null;       // agentProfile read fresh from db not from transaction.agentProfile
  let coAgentProfile = transaction?.coAgentId
    ? agentsForManagerActive?.agents?.filter(
        (ag) => ag.id === transaction.coAgentId,
      )[0]
    : null;
  const isCoAgentOneOfMyAgents =
    coAgentProfile?.managerId === transaction.managerId;

  if (!coAgentProfile && transaction?.coAgent) {
    coAgentProfile = transaction?.coAgent;    // TODO could be a problem or could be useful for future if coAgent allowed is not a user
  }

  const representedSide = transaction?.agentRepresents || "";
  const thisSideClientRoles =
    representedSide === "Buyer"
      ? ["Buyer", "Buyer 2", "Buyer 3"]
      : representedSide === "Seller"
      ? ["Seller", "Seller 2", "Seller 3"]
      : [];
  const thisSideClients = transactionParties.filter((p) =>
    thisSideClientRoles.includes(p.role)
  );

  function getTableHeader() {
    return (
      <Grid.Row className="zero padding">
        <Grid.Column mobile={16} computer={colSize.one}>
          <b> Description</b>
        </Grid.Column>
        <Grid.Column mobile={16} computer={colSize.two}>
          <b>Payable To</b>
        </Grid.Column>
        <Grid.Column mobile={16} computer={colSize.three}>
          <>
            <b>% Amount</b>{" "}
            <Popup
              flowing
              size="small"
              trigger={
                <Icon
                  name="info"
                  color="blue"
                  circular
                  inverted
                  size="tiny"
                  style={{
                    marginLeft: "3px",
                    marginBottom: "3px",
                  }}
                />
              }
            >
              <p className="bold text blue mini bottom margin">
                Percent vs Amount
                </p>
                <p>
                Fill out either the % (the system will auto-calculate the
                amount) <br />
                or fill out the $ amount (and ensure the % is blank).
                <br />
                <i>Make sure the "Payable To" is also filled out.</i>
              </p>

              {/* <p className="text-dark text-normal mini bottom margin">
                                  You can define the order in which the money is
                                  allocated inside your Profile.
                                </p> */}
            </Popup>
          </>
        </Grid.Column>
        <Grid.Column mobile={16} computer={colSize.four}>
          <b>$ Amount</b>
        </Grid.Column>
        <Grid.Column mobile={16} computer={colSize.five}>
          <>
            <b>Balance</b>

            <Popup
              flowing
              size="small"
              trigger={
                <Icon
                  name="info"
                  color="blue"
                  circular
                  inverted
                  size="tiny"
                  style={{
                    marginLeft: "3px",
                    marginBottom: "3px",
                  }}
                />
              }
            >
              <p className="bold text blue mini bottom margin">
                Balance shows the amount of compensation remaining
                <br />
                after the line item is applied.
              </p>

              {/* <p className="text-dark text-normal mini bottom margin">
                                  You can define the order in which the money is
                                  allocated inside your Profile.
                                </p> */}
            </Popup>
          </>
        </Grid.Column>
      </Grid.Row>
    );
  }
  function getPayToCoAgent(values, includeAdditionalFees = true) {
    const additionalFeesPaidByCoAgent = includeAdditionalFees
      ? getAdditionalFeesPaidByTotal(values, "coagent")
      : 0;
    return (
      getAsNumber(values?.financials?.CoAgentPayToPayAmount) -
      (brokerageDetails?.hasManagerFee
        ? getAsNumber(values?.financials?.coAgentManagerPayAmount)
        : 0) -
      (brokerageDetails?.hasDonationFee
        ? getAsNumber(values?.financials?.coAgentDonationPayAmount)
        : 0) -
      additionalFeesPaidByCoAgent
    );
  }
  function getAsNumber(amount) {
    if (!amount) return 0;
    // Handle currency strings like "$1,234.56"
    if (typeof amount === "string" && amount.includes("$")) {
      return parseCurrency(amount) || 0;
    }
    return !isNaN(amount) ? Number(amount) : 0;
  }

  function getBalanceAfterCreditDebit(values, baseCompensation) {
    // Sum all credits
    const totalCredits = (values?.credits || []).reduce(
      (sum, credit) => sum + getAsNumber(credit.amount),
      0,
    );
    // Sum all debits
    const totalDebits = (values?.debits || []).reduce(
      (sum, debit) => sum + getAsNumber(debit.amount),
      0,
    );
    return baseCompensation - totalCredits + totalDebits;
  }

  function getAdditionalFeePartyKey(value) {
    const normalized = (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");

    if (normalized === "coagent") return "coagent";
    if (normalized === "transactioncoordinator") return "tc";
    return normalized;
  }

  function getAdditionalFeeBaseCompensation(values) {
    return getBalanceAfterCreditDebit(
      values,
      getAsNumber(values?.financials?.compensationPayAmount),
    );
  }

  function getAdditionalFeePayerBase(paidBy, values) {
    const payerKey = getAdditionalFeePartyKey(paidBy);
    const baseCompensation = getAdditionalFeeBaseCompensation(values);

    switch (payerKey) {
      case "agent":
        return Math.max(getPayToAgent(values, false), 0) || baseCompensation;
      case "coagent":
        return Math.max(getPayToCoAgent(values, false), 0) || baseCompensation;
      case "brokerage":
        return Math.max(getPayToBrokerage(values, false), 0) || baseCompensation;
      case "manager":
        return getAsNumber(values?.financials?.ManagerPayAmount) || baseCompensation;
      case "tc":
        return getAsNumber(values?.financials?.TcPayAmount) || baseCompensation;
      default:
        return baseCompensation;
    }
  }

  function getAdditionalFeeAmount(fee, values) {
    const feeAmount = getAsNumber(fee?.feeAmount);
    if (!feeAmount) return 0;

    if (fee?.feeType === "percent") {
      return safelyRoundNumber(
        (getAdditionalFeePayerBase(fee?.paidBy, values) * feeAmount) / 100,
        2,
      );
    }

    return feeAmount;
  }

  function getAdditionalFeesToPay(values) {
    return (values?.fees?.additionalFees || [])
      .map((fee, index) => ({
        ...fee,
        index,
        amountCalculated: getAdditionalFeeAmount(fee, values),
      }))
      .filter((fee) => fee.payTo && fee.amountCalculated);
  }

  function getAdditionalFeesPaidByTotal(values, paidByKey) {
    return getAdditionalFeesToPay(values).reduce((total, fee) => {
      return getAdditionalFeePartyKey(fee.paidBy) === paidByKey
        ? total + fee.amountCalculated
        : total;
    }, 0);
  }

  function getAdditionalFeePayToName(fee, values) {
    const payToKey = getAdditionalFeePartyKey(fee?.payTo);
    switch (payToKey) {
      case "agent":
        return values?.financials?.agentPayToName || fee.payTo;
      case "coagent":
        return values?.financials?.coAgentPayToName || fee.payTo;
      case "brokerage":
        return values?.financials?.brokeragePayName || fee.payTo;
      case "manager":
        return values?.financials?.managerPayName || fee.payTo;
      case "team":
        return values?.fees?.feeTeamName || fee.payTo;
      case "tc":
        return values?.financials?.tcPayName || fee.payTo;
      default:
        return fee?.payTo || "";
    }
  }

  function getPayToBrokerage(values, includeAdditionalFees = true) {
    let payToBrokerage = getAsNumber(values?.financials?.BrokeragePayAmount);
    if (
      values?.fees?.creditPaidBy === "brokerage" &&
      Number(values?.fees?.creditAmount)
    ) {
      payToBrokerage -= Number(values?.fees?.creditAmount);
    }
    if (Number(values?.fees?.debitAmount)) {
      payToBrokerage += Number(values?.fees?.debitAmount);
    }
    if (
      values?.financials?.coAgentPayToBrokerageName ===
        values?.financials?.brokeragePayName &&
      Number(values?.financials?.CoAgentBrokeragePayAmount)
    ) {
      payToBrokerage += Number(values?.financials?.CoAgentBrokeragePayAmount);
    }
    if (Number(values?.fees?.feeTransactionFeeAmount)) {
      payToBrokerage += getAsNumber(values?.fees?.feeTransactionFeeAmount);
    }
    if (includeAdditionalFees) {
      payToBrokerage -= getAdditionalFeesPaidByTotal(values, "brokerage");
    }
    return payToBrokerage;
  }

  function getPayToAgent(values, includeAdditionalFees = true) {
    const credit =
      values.fees?.creditGoesTo === "agent"
        ? getAsNumber(values?.fees?.creditAmount)
        : values?.fees?.creditPaidBy === "agent"
          ? -getAsNumber(values.fees?.creditAmount)
          : 0;
    const transactionFee =
      brokerageDetails?.hasTransactionFee &&
      values?.fees?.feeTransactionWhoPays === "agent"
        ? getAsNumber(values?.fees?.feeTransactionFeeAmount)
        : 0;
    const additionalFeesPaidByAgent = includeAdditionalFees
      ? getAdditionalFeesPaidByTotal(values, "agent")
      : 0;

    return (
      getAsNumber(values?.financials?.AgentPayAmount) -
      transactionFee -
      (brokerageDetails?.hasManagerFee
        ? getAsNumber(values?.financials?.ManagerPayAmount)
        : 0) -
      (brokerageDetails?.hasDonationFee
        ? getAsNumber(values?.financials?.DonationPayAmount)
        : 0) -
      (transaction?.tcId ? getAsNumber(values?.financials?.TcPayAmount) : 0) +
      credit -
      getAsNumber(values?.fees?.debitAmount) -
      additionalFeesPaidByAgent
    );
  }
  function renderCDAListOfPayouts() {
    if (!cda) return "";
    const listItems = [];
    for (let i = 1; i <= 10 && cda["text" + i]?.length > 4; i++) {
      listItems.push(<li key={i}>{cda["text" + i]}</li>);
    }
    return listItems;
  }

  function parseCurrency(currencyString) {
    const cleanedString = currencyString.replace(/[^\d.-]/g, "");
    const number = parseFloat(cleanedString);
    if (isNaN(number)) {
      return null;
    }
    return number;
  }

  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });

  function getReferralParty(parties) {
    return parties?.find((party) => party.role === "Referral") || null;
  }

  function normalizeReferralFeeType(referralParty) {
    const feeType = (
      referralParty?.referralFeeType ||
      referralParty?.referralAmountType ||
      referralParty?.feeReferralFeeType ||
      ""
    ).toString().toLowerCase();
    if (["dollar", "dollars", "$"].includes(feeType)) return "dollars";
    if (["percent", "%"].includes(feeType)) return "percent";
    return "";
  }

  function getReferralFeeValue(referralParty, referralFeeType) {
    if (!referralParty) return "";
    if (
      referralParty.referralFeeAmount !== undefined &&
      referralParty.referralFeeAmount !== null &&
      referralParty.referralFeeAmount !== ""
    ) {
      return referralParty.referralFeeAmount;
    }
    if (
      referralParty.feeReferralFeeAmount !== undefined &&
      referralParty.feeReferralFeeAmount !== null &&
      referralParty.feeReferralFeeAmount !== ""
    ) {
      return referralParty.feeReferralFeeAmount;
    }
    if (referralFeeType === "percent") {
      return (
        referralParty.referralPercent ||
        referralParty.referralPercentAmount ||
        referralParty.referralFeeValue ||
        ""
      );
    }
    if (referralFeeType === "dollars") {
      return referralParty.referralDollarAmount || referralParty.referralAmount || "";
    }
    return "";
  }

  function getReferralPayToName(referralParty) {
    if (!referralParty) return "";
    return (
      referralParty.payToName ||
      referralParty.referralPayToName ||
      referralParty.fees?.agentPayToName ||
      convertFullName(referralParty) ||
      ""
    );
  }

  const colSize = { one: 3, two: 4, three: 3, four: 3, five: 3 };
  // const feeDescription = [
  //   {
  //     key: "",
  //     value: "",
  //     text: "",
  //   },
  //   {
  //     key: "Referral",
  //     value: "Referral",
  //     text: "Referral",
  //   },
  //   {
  //     key: "Brokerage",
  //     value: "Brokerage",
  //     text: "Brokerage",
  //   },
  //   {
  //     key: "Franchise",
  //     value: "Franchise",
  //     text: "Franchise",
  //   },
  //   {
  //     key: "Donation",
  //     value: "Donation",
  //     text: "Donation",
  //   },
  //   {
  //     key: "Credit",
  //     value: "Credit",
  //     text: "Credit",
  //   },
  // ];

  const amountType = [
    {
      key: "",
      value: "",
      text: "",
    },
    {
      key: "dollars",
      value: "dollars",
      text: "$",
    },
    {
      key: "percent",
      value: "percent",
      text: "%",
    },
  ];

  function resetCdaText() {
    for (let i = 1; i <= 10; i++) {
      cda["text" + i] = "";
    }
  }
  function resetBalance(setFieldValue) {
    for (var key in balance) {
      balance[key] = 0;
      setFieldValue(balance[key], "");
    }
  }

  let cda = {
    text1: "",
    text2: "",
    text3: "",
    text4: "",
    text5: "",
    text6: "",
    text7: "",
    text8: "",
    text9: "",
    text10: "",
    compensationPayAmount: "",
    specialInstructions: brokerageDetails?.cdaDefaultSpecialInstructions || "",
  };

  let compensation =
    (parseCurrency(transaction?.salesPrice) || 0) &&
    transaction?.compensation?.compensationAmount &&
    transaction?.compensation?.compensationType === "percent"
      ? (parseCurrency(transaction.salesPrice) *
          transaction.compensation.compensationAmount) /
        100
      : getAsNumber(transaction?.compensation?.compensationAmount);

  const referralParty = getReferralParty(transactionParties);
  const referralFeeType = normalizeReferralFeeType(referralParty);
  const referralFeeValue = getReferralFeeValue(referralParty, referralFeeType);

  let balance = {
    compensation: 0,
    Referral: 0,
    Other: 0,
    CoAgent: 0,
    Brokerage: 0,
    Manager: 0,
    Transaction: 0,
    Donation: 0,
    Tc: 0,
    Agent: 0,
  };

  let initialValues = {
    balance: {
      compensation: "",
      OtherSide: "",
      Referral: "",
      CoAgent: "",
      Brokerage: "",
      Manager: "",
      Transaction: "",
      Donation: "",
      Tc: "",
      Agent: "",
    },
    cda: {
      text1: "",
      text2: "",
      text3: "",
      text4: "",
      text5: "",
      text6: "",
      text7: "",
      text8: "",
      text9: "",
      text10: "",
      compensationPayAmount: "",
      specialInstructions:
        brokerageDetails?.cdaDefaultSpecialInstructions || "",
    },
    financials: {
      salesPrice: transaction?.salesPrice || "",
      compensationAmount: transaction?.compensation?.compensationAmount || "",
      compensationType: transaction?.compensation?.compensationType || "",
      compensationPayAmount: compensation,
      // otherPayName: "",
      // OtherPayAmount: "",
      referralPayName: getReferralPayToName(referralParty),
      ReferralPayAmount:
        referralFeeType === "dollars" ? referralFeeValue : "",

      agentPayToName:
        agentProfile?.fees?.agentPayToName ||
        convertFullName(agentProfile) ||
        "",
      AgentPayAmount: "",
      coAgentPayToName: coAgentProfile ? convertFullName(coAgentProfile) : "",
      CoAgentPayAmount: "",
      CoAgentPayToPayAmount: "",
      coAgentPayToBrokerageName: "",
      CoAgentBrokeragePayAmount: "",
      coAgentManagerPayName: brokerageDetails?.hasManagerFee
        ? convertFullName(currentUserProfile)
        : "",
      coAgentManagerPayAmount: brokerageDetails?.hasManagerFee
        ? coAgentProfile?.fees?.feeManagerFeeAmount
        : "",
      coAgentDonationPayName: brokerageDetails?.hasDonationFee
        ? coAgentProfile?.fees?.feeDonationPayName
        : "",
      coAgentDonationPayAmount:
        // brokerageDetails?.hasDonationFee &&
        // coAgentProfile?.fees?.feeDonationFeeType === "dollars"
        //   ? coAgentProfile?.fees?.feeDonationFeeAmount
        //   : "",
        coAgentProfile?.fees?.feeDonationFeeType === "dollars" 
        ? (coAgentProfile.fees.feeDonationFeeAmount || 0) : "",

      brokeragePayName: agentProfile?.brokerageName || "",

      BrokeragePayAmount:
        agentProfile?.fees?.feeBrokerageFeeType === "dollars"
          ? agentProfile?.fees?.feeBrokerageFeeAmount
          : "",
      ManagerPayAmount:
        brokerageDetails?.hasManagerFee &&
        agentProfile?.fees?.feeManagerFeeType === "dollars"
          ? agentProfile?.fees?.feeManagerFeeAmount
          : "",
      managerPayName: brokerageDetails?.hasManagerFee
        ? convertFullName(currentUserProfile)
        : "",
      TransactionPayAmount: "",
      DonationPayAmount:
        agentProfile?.fees?.feeDonationFeeType === "dollars"
          ? (agentProfile?.fees?.feeDonationFeeAmount || 0)
          : 0,
      donationPayName: brokerageDetails?.hasDonationFee
        ? agentProfile?.fees?.feeDonationPayName
        : "",
      tcPayName: "",
      TcPayAmount: "",
    },
    fees: {
      agentFullName: agentProfile ? convertFullName(agentProfile) : "",
      agentPayAmount: "",
      feeAgentFeePercent:
        agentProfile?.fees?.feeBrokerageFeeType === "percent"
          ? 100 - getAsNumber(agentProfile?.fees?.feeBrokerageFeeAmount)
          : "",

      coAgentFeeAmount: "",
      feeCoAgentBrokeragePayToFeePercent: "",
      feeCoAgentFeePercent: "",
      coAgentFeeManagerFeePercent:
        brokerageDetails?.hasManagerFee &&
        coAgentProfile?.fees?.feeManagerFeeType === "percent"
          ? coAgentProfile?.fees?.feeManagerFeeAmount
          : "",
      coAgentFeeDonationFeePercent:
        brokerageDetails?.hasDonationFee &&
        coAgentProfile?.fees?.feeDonationFeeType === "percent"
          ? coAgentProfile.fees.feeDonationFeeAmount
          : "",
      feeOtherSideFeePercent: "",
      feeReferralFeeAmount:
        transaction?.fees?.feeReferralFeeAmount ||
        (referralFeeType === "dollars" ? referralFeeValue : ""),
      feeReferralFeePercent:
        referralFeeType === "percent" ? referralFeeValue : "",
      feeReferralFeeType: referralFeeType,
      feeBrokerageFeeAmount: agentProfile?.fees?.feeBrokerageFeeAmount || "",
      feeBrokerageFeePercent:
        agentProfile?.fees?.feeBrokerageFeeType === "percent"
          ? agentProfile?.fees?.feeBrokerageFeeAmount
          : "",
      feeBrokerageFeeType: agentProfile?.fees?.feeBrokerageFeeType || "",
      feeFranchisePayName: "",
      feeFranchiseFeePercent:
        brokerageDetails?.hasFranchiseFee &&
        agentProfile?.fees?.feeFranchiseFeeType === "percent"
          ? agentProfile?.fees?.feeFranchiseFeeAmount
          : "",
      feeFranchiseFeeAmount: brokerageDetails?.hasFranchiseFee
        ? agentProfile?.fees?.feeFranchiseFeeAmount || ""
        : "",
      feeFranchiseFeeType: agentProfile?.fees?.feeFranchiseFeeType || "",
      feeManagerFeeAmount: brokerageDetails?.hasManagerFee
        ? agentProfile?.fees?.feeManagerFeeAmount
        : "",
      feeManagerFeePercent:
        brokerageDetails?.hasManagerFee &&
        agentProfile?.fees?.feeManagerFeeType === "percent"
          ? agentProfile?.fees?.feeManagerFeeAmount
          : "",
      feeManagerFeeType: brokerageDetails?.hasManagerFee
        ? agentProfile?.fees?.feeManagerFeeType
        : "",
      feeManagerPayName: brokerageDetails?.hasManagerFee
        ? agentProfile?.fees?.feeManagerPayName
        : "",
      feeMentorFeeAmount: brokerageDetails?.hasMentorFee
        ? agentProfile?.fees?.feeMentorFeeAmount || ""
        : "",
      feeMentorFeeType: brokerageDetails?.hasMentorFee
        ? agentProfile?.fees?.feeMentorFeeType || ""
        : "",
      feeTransactionFeeAmount: brokerageDetails?.hasTransactionFee
        ? agentProfile?.fees?.feeTransactionFeeAmount || ""
        : "",
      feeTransactionWhoPays: agentProfile?.fees?.feeTransactionWhoPays || "",
      feeDonationFeeAmount: brokerageDetails?.hasDonationFee
        ? agentProfile?.fees?.feeDonationFeeAmount || ""
        : "",
      feeDonationFeePercent:
        brokerageDetails?.hasDonationFee &&
        agentProfile?.fees?.feeDonationFeeType === "percent"
          ? agentProfile?.fees?.feeDonationFeeAmount
          : "",
      feeDonationPayName: brokerageDetails?.hasDonationFee
        ? agentProfile?.fees?.feeDonationPayName || ""
        : "",
      feeTeamName: "",
      feeTeamFeeAmount: "",
      feeTeamFeeType: "",
      feeDeskAmount: "",
      feeDeskFreq: "",
      additionalFees: agentProfile?.fees?.additionalFees || [],
      creditAmount: "",
      creditGoesTo: "",
      creditPaidBy: "",
      debitReason: "",
      debitAmount: "",
      // ...agent.fees,
    },
    credits: [],
    debits: [],
    coAgent: transaction?.coAgent || null,
  };
  //   const agentFeeValues = agent ? [...initialValues, ...agent] : initialValues;

  const validationSchema = Yup.object({
    // lastName: Yup.string().required("You must provide a last name"),
  });

  const fieldKey = "financials.";
  function handleChangeForFee(
    setFieldValue,
    feeName,
    currentCompensation,
    percentAmount,
    dollarAmount,
    payTo,
    position,
    setPayLineInCDA,
    cdaPayoutAdjustment = 0,
  ) {
    if (payTo?.length < 1) {
      setFieldValue(fieldKey + feeName + "PayAmount", "");
      setFieldValue("balance." + feeName, "");
      return currentCompensation;
    }
    let payAmount = 0;
    if (percentAmount && !isNaN(percentAmount)) {
      payAmount = (currentCompensation * getAsNumber(percentAmount)) / 100;

      setFieldValue(fieldKey + feeName + "PayAmount", payAmount.toFixed(2));
    } else {
      payAmount = getAsNumber(dollarAmount);
    }
    balance[feeName] = currentCompensation - payAmount;

    setFieldValue(
      "balance." + feeName,
      currencyFormatter.format(balance[feeName]),
    );

    if (setPayLineInCDA) {
      const cdaPayAmount = payAmount + cdaPayoutAdjustment;
      cda["text" + position.lineNum++] =
        payTo + " " + currencyFormatter.format(cdaPayAmount);
    }

    return currentCompensation - payAmount;
  }

  // function setCurrencyValueInForm(setFieldValue, namedInput, newValue) {
  //   setFieldValue(namedInput, currencyFormatter.format(newValue));
  // }
  function Watcher() {
    const { values, setFieldValue } = useFormikContext();

    // Only track input fields that should trigger recalculation
    const inputs = JSON.stringify({
      salesPrice: values?.financials?.salesPrice,
      compensationAmount: values?.financials?.compensationAmount,
      compensationType: values?.financials?.compensationType,
      referralPayName: values?.financials?.referralPayName,
      feeReferralFeePercent: values?.fees?.feeReferralFeePercent,
      ReferralPayAmount: values?.financials?.ReferralPayAmount,
      coAgentPayToName: values?.financials?.coAgentPayToName,
      feeCoAgentFeePercent: values?.fees?.feeCoAgentFeePercent,
      CoAgentPayAmount: values?.financials?.CoAgentPayAmount,
      feeCoAgentPayToFeePercent: values?.fees?.feeCoAgentPayToFeePercent,
      CoAgentPayToPayAmount: values?.financials?.CoAgentPayToPayAmount,
      coAgentManagerPayAmount: values?.financials?.coAgentManagerPayAmount,
      brokeragePayName: values?.financials?.brokeragePayName,
      feeBrokerageFeePercent: values?.fees?.feeBrokerageFeePercent,
      BrokeragePayAmount: values?.financials?.BrokeragePayAmount,
      managerPayName: values?.financials?.managerPayName,
      feeManagerFeePercent: values?.fees?.feeManagerFeePercent,
      ManagerPayAmount: values?.financials?.ManagerPayAmount,
      feeTransactionWhoPays: values?.fees?.feeTransactionWhoPays,
      donationPayName: values?.financials?.donationPayName,
      feeDonationFeePercent: values?.fees?.feeDonationFeePercent,
      DonationPayAmount: values?.financials?.DonationPayAmount,
      tcPayName: values?.financials?.tcPayName,
      TcPayAmount: values?.financials?.TcPayAmount,
      agentPayToName: values?.financials?.agentPayToName,
      feeAgentFeePercent: values?.fees?.feeAgentFeePercent,
      AgentPayAmount: values?.financials?.AgentPayAmount,
      creditAmount: values?.fees?.creditAmount,
      creditPaidBy: values?.fees?.creditPaidBy,
      creditGoesTo: values?.fees?.creditGoesTo,
      debitAmount: values?.fees?.debitAmount,
      additionalFees: JSON.stringify(values?.fees?.additionalFees || []),
      credits: JSON.stringify(values?.credits || []),
      debits: JSON.stringify(values?.debits || []),
    });

    useEffect(() => {
      resetCdaText();
      resetBalance(setFieldValue);
      if (
        values?.financials?.salesPrice &&
        values?.financials?.compensationAmount &&
        values?.financials?.compensationType
      ) {
        let compAmt = 0;

        if (values.financials.compensationType === "dollars") {
          compAmt = parseCurrency(values.financials.compensationAmount) || 0;
        } else if (values.financials.compensationType === "percent") {
          compAmt =
            ((parseCurrency(values.financials.salesPrice) || 0) *
              (Number(values.financials.compensationAmount) || 0)) /
            100;
          compAmt = safelyRoundNumber(compAmt, 2);
        } else {
          compAmt = 0;
        }
        setFieldValue(
          fieldKey + "compensationPayAmount",
          currencyFormatter.format(compAmt),
        );
        setFieldValue(
          "cda.compensationPayAmount",
          currencyFormatter.format(compAmt),
        );

        balance.compensation = compAmt;

        if (compAmt === 0) return;

        // Account for Credits and Debits before calculating other splits
        let totalCredits = (values?.credits || []).reduce(
          (sum, credit) => sum + getAsNumber(credit.amount),
          0,
        );
        let totalDebits = (values?.debits || []).reduce(
          (sum, debit) => sum + getAsNumber(debit.amount),
          0,
        );
        totalCredits = safelyRoundNumber(totalCredits, 2);
        totalDebits = safelyRoundNumber(totalDebits, 2);

        // Adjust compAmt for credits and debits
        compAmt = compAmt - totalCredits + totalDebits;

        let position = { lineNum: 1 };

        // if (values?.financials?.referralPayName?.length > 0) {
        compAmt = handleChangeForFee(
          setFieldValue,
          "Referral",
          compAmt,
          values?.fees?.feeReferralFeePercent,
          values.financials.ReferralPayAmount,
          values.financials.referralPayName,
          position,
          true,
        );

        // if (
        //   values?.financials?.coAgentPayToName ||
        //   values?.financials?.coAgentPayToBrokerage
        // )
        console.log("START COAGENT");
        if (transaction?.coAgent?.firstName?.length > 0) {
          compAmt = handleChangeForFee(
            setFieldValue,
            "CoAgent",
            compAmt,
            values?.fees?.feeCoAgentFeePercent,
            values?.financials?.CoAgentPayAmount,
            values?.financials?.coAgentPayToName,
            position,
            false,
          );
          // totalCoAgentSideDollarSplitAmount is the total amount that goes towards CoAgent then break down below with fees
          const totalCoAgentSideDollarSplitAmount = safelyRoundNumber(
            Number(values?.financials?.CoAgentPayAmount) || 0,
            2,
          );
          //console.log("CoAgentPayAmount", values?.financials?.CoAgentPayAmount);
          console.log(
            "totalCoAgentSideDollarSplitAmount ",
            totalCoAgentSideDollarSplitAmount,
          );

          // const coAgentDollarAmountSplit =
          //   (Number(values?.fees?.feeCoAgentFeePercent) / 100) *
          //     totalCoAgentSideDollarSplitAmount || 0;
          // console.log(
          //   "values?.fees?.feeCoAgentFeePercent",
          //   values?.fees?.feeCoAgentFeePercent,
          // );
          // console.log("coAgentDollarAmountSplit", coAgentDollarAmountSplit);
          // Number(values?.financials?.CoAgentPayAmount) || 0;
          //feeCoAgentPayToFeePercent;
          const payToCoAgentPercent = safelyRoundNumber(
            Number(values?.fees?.feeCoAgentPayToFeePercent) || 0,
            3,
          );
          console.log(
            "values?.fees?.feeCoAgentPayToFeePercent this is coAgent split % ",
            values?.fees?.feeCoAgentPayToFeePercent,
          );
          console.log("payToCoAgentPercent", payToCoAgentPercent); // CoAgent split with brokerage % to agent
          let payToCoAgentBrokeragePercent = safelyRoundNumber(
            100 - payToCoAgentPercent,
            3,
          );
          console.log(
            "payToCoAgentBrokeragePercent the split paid to Brokerage for CoAgent",
            payToCoAgentBrokeragePercent,
          );
          const coAgentDollarAmountSplit = safelyRoundNumber(
            (payToCoAgentPercent / 100) * totalCoAgentSideDollarSplitAmount,
            2,
          );
          console.log("coAgentDollarAmountSplit", coAgentDollarAmountSplit);
          // let payToCoAgent =
          //   Number(values?.financials?.CoAgentPayToPayAmount) || 0;
          // let payToCoAgentBrokerage =
          //   Number(values?.fees?.feeCoAgentBrokeragePayAmount) || 0;
          let coAgentPayToName = values?.financials?.coAgentPayToName || "";
          // let coAgentPayToBrokerage =
          //   values?.financials?.coAgentPayToBrokerage || "";
          // let coAgentBrokeragePayToName =
          //   values?.financials?.coAgentPayToBrokerageName || "";

          if (
            // dollar amount calculated, and entered % for agent
            payToCoAgentPercent &&
            payToCoAgentPercent > 0 &&
            coAgentDollarAmountSplit >= 0
          ) {
            const coAgentPayToAmount = coAgentDollarAmountSplit;
            //(payToCoAgentPercent / 100) * coAgentDollarAmountSplit;
            setFieldValue(
              "financials.CoAgentPayToPayAmount",
              coAgentPayToAmount.toFixed(2),
            );

            setFieldValue(
              "fees.feeCoAgentBrokeragePayToFeePercent",
              payToCoAgentBrokeragePercent.toFixed(3),
            );

            const coAgentBrokerageAmount = safelyRoundNumber(
              totalCoAgentSideDollarSplitAmount - coAgentPayToAmount,
              2,
            );
           
            setFieldValue(
              "financials.CoAgentBrokeragePayAmount",
              coAgentBrokerageAmount.toFixed(2),
            );
          }
          if (isCoAgentOneOfMyAgents && brokerageDetails?.hasDonationFee) {
            const valuesCoAgentFeeDonationFeePercent = Number(values?.fees?.coAgentFeeDonationFeePercent || 0);
            const existingCoAgentDonationPayAmount =
              values?.financials?.coAgentDonationPayAmount;
            const hasExistingCoAgentDonationPayAmount =
              existingCoAgentDonationPayAmount !== undefined &&
              existingCoAgentDonationPayAmount !== null &&
              existingCoAgentDonationPayAmount !== "";
            const calculatedCoAgentDonationPayAmount =
              valuesCoAgentFeeDonationFeePercent > 0
                ? (valuesCoAgentFeeDonationFeePercent * coAgentDollarAmountSplit) /
                  100.0
                : 0;
            const coAgentDonationPayAmount = hasExistingCoAgentDonationPayAmount
              ? getAsNumber(existingCoAgentDonationPayAmount)
              : calculatedCoAgentDonationPayAmount;

            if (!hasExistingCoAgentDonationPayAmount && coAgentDonationPayAmount > 0) {
              setFieldValue(
                "financials.coAgentDonationPayAmount",
                coAgentDonationPayAmount.toFixed(2),
              );
            }
            cda["text" + position.lineNum++] =
              values.financials.coAgentDonationPayName +
              " " +
              currencyFormatter.format(coAgentDonationPayAmount);
          }
          cda["text" + position.lineNum++] =
            coAgentPayToName +
            "  " +
            currencyFormatter.format(getPayToCoAgent(values));
          // if (
          //   coAgentBrokeragePayToName === values?.financials?.brokeragePayName
          // ) {
          // }
        }
        // setFieldValue(
        //   "financials.AgentPayAmount",
        //   currencyFormatter.format(payToAgent)
        // );
        // setFieldValue(
        //   "balance.Agent",
        //   currencyFormatter.format(compensationRemaining - payToAgent)
        // );
        // agent percent
        // const agentSplitPercent = values?.fees?.feeBrokerageFeePercent
        //   ? 100 - getAsNumber(values?.fees?.feeBrokerageFeePercent)
        //   : "";
        handleChangeForFee(
          setFieldValue,
          "Agent",
          compAmt,
          values?.fees?.feeAgentFeePercent,
          values.financials.AgentPayAmount,
          values.financials.agentPayToName,
          position,
          false,
        );

        if (values?.financials?.brokeragePayName) {
          handleChangeForFee(
            setFieldValue,
            "Brokerage",
            compAmt,
            values?.fees?.feeBrokerageFeePercent,
            values.financials.BrokeragePayAmount,
            values.financials.brokeragePayName,
            position,
            false,
          );
          // brokerage balance not correct

          compAmt =
            compAmt -
            getAsNumber(values?.financials?.AgentPayAmount) -
            getAsNumber(values?.financials?.BrokeragePayAmount);
          // setCurrencyValueInForm(setFieldValue, "balance.Brokerage", compAmt);
          // setFieldValue("balance.Brokerage", currencyFormatter.format(compAmt));
          // do stuff for brokerage
          let payToBrokerage = getPayToBrokerage(values);
          let extraBrokerageInfo = "";
          if (Number(values?.fees?.feeTransactionFeeAmount)) {
            extraBrokerageInfo =
              " [includes Transaction Fee Amount of " +
              currencyFormatter.format(values?.fees?.feeTransactionFeeAmount) +
              " paid by " +
              values?.fees?.feeTransactionWhoPays +
              " ]";
          }

          cda["text" + position.lineNum++] =
            values.financials.brokeragePayName +
            "  " +
            currencyFormatter.format(payToBrokerage) +
            extraBrokerageInfo;
        }
        if (
          currentUserProfile?.brokerage?.hasManagerFee &&
          values?.financials?.managerPayName
        ) {
          compAmt = handleChangeForFee(
            setFieldValue,
            "Manager",
            compAmt,
            values?.fees?.feeManagerFeePercent,
            values.financials.ManagerPayAmount,
            values.financials.managerPayName,
            position,
            true,
            -getAdditionalFeesPaidByTotal(values, "manager"),
          );
        }
        if (
          currentUserProfile?.brokerage?.hasTransactionFee &&
          values?.fees?.feeTransactionWhoPays
        ) {
          handleChangeForFee(
            setFieldValue,
            "Transaction",
            compAmt,
            values?.fees?.feeTransactionFeePercent,
            values.financials.TransactionPayAmount,
            values.fees?.feeTransactionWhoPays,
            position,
            false,
          );
        }
        if (
          currentUserProfile?.brokerage?.hasDonationFee &&
          values?.financials?.donationPayName
        ) {
          handleChangeForFee(
            setFieldValue,
            "Donation",
            compAmt,
            values?.fees?.feeDonationFeePercent,
            values.financials.DonationPayAmount,
            values.financials.donationPayName,
            position,
            true,
          );
        }
        if (
          transaction.tcId?.length > 0 &&
          values?.financials?.tcPayName?.length
        ) {
          handleChangeForFee(
            setFieldValue,
            "Tc",
            compAmt,
            "",
            values.financials.TcPayAmount,
            values.financials.tcPayName,
            position,
            true,
            -getAdditionalFeesPaidByTotal(values, "tc"),
          );
        }
        // let payToAgent = compensationRemaining;
        // if (
        //   values.fees?.creditPaidBy === "agent" &&
        //   !isNaN(values.fees?.creditAmount)
        // ) {
        //   payToAgent -= Number(values.fees?.creditAmount);
        // }
        // if (!isNaN(values.fees?.debitAmount)) {
        //   payToAgent -= Number(values.fees?.debitAmount);
        // }

        // if (values?.fees?.feeBrokerageFeePercent) {
        //   setFieldValue(
        //     "fees.feeAgentFeePercent",
        //     100 - values.fees.feeBrokerageFeePercent
        //   );
        // }
        // setFieldValue(
        //   "financials.AgentPayAmount",
        //   currencyFormatter.format(payToAgent)
        // );
        // setFieldValue(
        //   "balance.Agent",
        //   currencyFormatter.format(compensationRemaining - payToAgent)
        // );

        getAdditionalFeesToPay(values).forEach((fee) => {
          const feeName = fee.name || fee.description || "Additional Fee";
          const paidBy = fee.paidBy ? ` paid by ${fee.paidBy}` : "";
          const payToName = getAdditionalFeePayToName(fee, values);
          cda["text" + position.lineNum++] = `${payToName} ${currencyFormatter.format(
            fee.amountCalculated,
          )} (${feeName}${paidBy})`;
        });

        cda["text" + position.lineNum++] =
          values.financials.agentPayToName +
          " " +
          currencyFormatter.format(getPayToAgent(values));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputs]);
    return null;
  }

  return (
    <ModalWrapper>
      <Segment clearing id="manager-financials-edit-form">
        <div className="large horizontal margin small top margin">
          <Header size="large" color="blue">
            Transaction Financials : {transaction.address.street}{" "}
            {transaction.city}
          </Header>
          {(thisSideClients.length > 0 || agentProfile) && (
            <div style={{ marginBottom: "1rem", marginTop: "0.5rem", padding: "0.75rem 1rem", backgroundColor: "#f8f9fb", borderRadius: "6px", borderLeft: "4px solid #4e9af1" }}>
              {thisSideClients.length > 0 && (
                <>
                  <div style={{ fontWeight: "bold", color: "#444", marginBottom: "0.4rem" }}>
                    This Side&apos;s Clients
                  </div>
                  {thisSideClients.map((client) => {
                    const fullName = convertFullName(client);
                    return (
                      <div key={client.id || client.email} style={{ marginTop: "0.35rem", paddingLeft: "0.75rem", fontSize: "0.93em", lineHeight: "1.5" }}>
                        <strong>{fullName}</strong>
                        {" "}
                        <span style={{ color: "#888" }}>({client.role})</span>
                        {client.isTrust && client.entityName && (
                          <span>
                            {" — "}Taking title as: <em>{client.entityName}</em>
                            {client.authorityTitle
                              ? `; ${fullName}, ${client.authorityTitle}`
                              : ""}
                          </span>
                        )}
                        {client.hasPoa && client.poaFullName && (
                          <span>
                            {" — "}POA: <strong>{client.poaFullName}</strong>, Attorney-in-Fact
                            {" "}for {fullName}
                          </span>
                        )}
                      </div>
                    );
                  })}
                </>
              )}
              {agentProfile && (
                <>
                  <div style={{ fontWeight: "bold", color: "#444", marginTop: thisSideClients.length > 0 ? "0.7rem" : "0", marginBottom: "0.4rem" }}>
                    This Side&apos;s Agent
                  </div>
                  <div style={{ paddingLeft: "0.75rem", fontSize: "0.93em", lineHeight: "1.5" }}>
                    <strong>{convertFullName(agentProfile)}</strong>
                    {agentProfile?.fees?.agentPayToName && (
                      <span>{" — "}Payable To: <strong>{agentProfile.fees.agentPayToName}</strong></span>
                    )}
                  </div>
                  {coAgentProfile && (
                    <div style={{ paddingLeft: "0.75rem", fontSize: "0.93em", lineHeight: "1.5", marginTop: "0.35rem" }}>
                      <strong>{convertFullName(coAgentProfile)}</strong>
                      {" "}
                      <span style={{ color: "#888" }}>(Co-Agent)</span>
                      {coAgentProfile?.fees?.agentPayToName && (
                        <span>{" — "}Payable To: <strong>{coAgentProfile.fees.agentPayToName}</strong></span>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          )}
          <Grid centered stackable className="zero bottom margin">
            <Grid.Column width={16}>
              <Segment clearing>
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  validateOnChange={false}
                  validateOnBlur={false}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      const finan = {
                        cda: {
                          ...cda,
                          specialInstructions: values.cda.specialInstructions,
                          compensationPayAmount:
                            values.cda.compensationPayAmount,
                        },
                      };
                      await updateTransFieldsInDb(transaction.id, finan);
                      setSubmitting(false);
                      toast.success("CDA details successfully updated");
                      // dispatch(
                      //   closeModal({
                      //     modalType: "ManagerAgentFinancialsEditForm",
                      //   })
                      // );
                      //  THIS ISN'T WORKING ON PAGE REFRESH BECAUSE NO FORMS!!!
                      const formsAdded = [];
                      const formToAdd = forms.find(
                        (form) =>
                          form.title ===
                          "Commission Disbursement Authorization",
                      );
                      formsAdded.push(formToAdd);
                      if (formsAdded) {
                        await addFormsToTransaction(
                          transaction,
                          formsAdded,
                          currentUserProfile,
                        );
                      }
                      dispatch(
                        closeModal({
                          modalType: "ManagerAgentFinancialsEditForm",
                        }),
                      );
                      navigate(`/transactions/${transaction.id}/documents`);
                    } catch (error) {
                      toast.error(error.message);
                      setSubmitting(false);
                    }
                  }}
                >
                  {({ isSubmitting, dirty, values, setFieldValue }) => (
                    <Form className="ui form tiny margin bottom">
                      <Watcher />
                      <Header color="blue">Transaction Details</Header>
                      <Grid>
                        <Grid.Row>
                          <Grid.Column mobile={16} computer={4}>
                            <MyTextInput
                              name={"financials.salesPrice"}
                              label="Transaction Sales Price"
                            />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={4}>
                            <MyTextInput
                              name={"financials.compensationAmount"}
                              label="Compensation Amount"
                            />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={4}>
                            <MySelectInput
                              name={"financials.compensationType"}
                              options={amountType}
                              label="Compensation Type"
                              style={{ maxWidth: "6em" }}
                            ></MySelectInput>
                          </Grid.Column>

                          <Grid.Column mobile={16} computer={4}>
                            <MyTextInput
                              disabled
                              name={"financials.compensationPayAmount"}
                              label="Total Compensation"
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>

                      {/* Credit/Debit Spreadsheet Section */}
                      {/* <Divider />
                      <Header color="blue">Credit / Debit</Header> */}

                      {(values.credits?.length > 0 ||
                        values.debits?.length > 0) && (
                        <Grid stackable>
                          {/* Header Row */}
                          <Grid.Row className="zero bottom padding">
                            <Grid.Column mobile={1} computer={1}>
                              <strong></strong>
                            </Grid.Column>
                            <Grid.Column mobile={3} computer={3}>
                              <strong>Type</strong>
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={3}>
                              <strong>To / Reason</strong>
                            </Grid.Column>
                            <Grid.Column mobile={3} computer={3}>
                              <strong>Paid By</strong>
                            </Grid.Column>
                            <Grid.Column mobile={3} computer={3}>
                              <strong>$ Amount</strong>
                            </Grid.Column>
                            <Grid.Column mobile={2} computer={3}>
                              <strong>Balance</strong>
                            </Grid.Column>
                          </Grid.Row>

                          {/* Dynamic Credit Rows */}
                          {values.credits?.map((credit, index) => {
                            let runningBalance = getAsNumber(
                              values?.financials?.compensationPayAmount,
                            );
                            // Subtract all credits up to and including this one
                            for (let i = 0; i <= index; i++) {
                              runningBalance -= getAsNumber(
                                values.credits[i].amount,
                              );
                            }

                            return (
                              <Grid.Row
                                key={`credit-${index}`}
                                className="zero top padding"
                              >
                                <Grid.Column mobile={1} computer={1}>
                                  <Button
                                    type="button"
                                    icon="trash"
                                    size="mini"
                                    color="red"
                                    onClick={() => {
                                      const newCredits = values.credits.filter(
                                        (_, i) => i !== index,
                                      );
                                      setFieldValue("credits", newCredits);
                                    }}
                                  />
                                </Grid.Column>
                                <Grid.Column mobile={3} computer={3}>
                                  <MyTextInput
                                    disabled
                                    name={`credit-label-${index}`}
                                    value="Credit"
                                  />
                                </Grid.Column>
                                <Grid.Column mobile={4} computer={3}>
                                  <MyTextInput
                                    name={`credits[${index}].to`}
                                    placeholder="Credit to..."
                                  />
                                </Grid.Column>
                                <Grid.Column mobile={3} computer={3}>
                                  <MySelectInput
                                    name={`credits[${index}].paidBy`}
                                    options={[
                                      {
                                        key: "",
                                        value: "",
                                        text: "Select...",
                                      },
                                      {
                                        key: "agent",
                                        value: "agent",
                                        text: "Agent",
                                      },
                                      {
                                        key: "brokerage",
                                        value: "brokerage",
                                        text: "Brokerage",
                                      },
                                      {
                                        key: "client",
                                        value: "client",
                                        text: "client",
                                      },
                                    ]}
                                  />
                                </Grid.Column>
                                <Grid.Column mobile={3} computer={3}>
                                  <MyTextInput
                                    name={`credits[${index}].amount`}
                                    placeholder="0.00"
                                  />
                                </Grid.Column>
                                <Grid.Column mobile={2} computer={3}>
                                  <div className="field">
                                    <input
                                      type="text"
                                      disabled
                                      value={currencyFormatter.format(
                                        runningBalance,
                                      )}
                                      style={{ backgroundColor: "#f9fafb" }}
                                    />
                                  </div>
                                </Grid.Column>
                              </Grid.Row>
                            );
                          })}

                          {/* Dynamic Debit Rows */}
                          {values.debits?.map((debit, index) => {
                            let runningBalance = getAsNumber(
                              values?.financials?.compensationPayAmount,
                            );
                            // Subtract all credits
                            if (values && values.credits)
                              values.credits.forEach((credit) => {
                                runningBalance -= getAsNumber(credit.amount);
                              });
                            // Add all debits up to and including this one
                            for (let i = 0; i <= index; i++) {
                              runningBalance += getAsNumber(
                                values.debits[i].amount,
                              );
                            }

                            return (
                              <Grid.Row
                                key={`debit-${index}`}
                                className="zero top padding"
                              >
                                <Grid.Column mobile={1} computer={1}>
                                  <Button
                                    type="button"
                                    icon="trash"
                                    size="mini"
                                    color="red"
                                    onClick={() => {
                                      const newDebits = values.debits.filter(
                                        (_, i) => i !== index,
                                      );
                                      setFieldValue("debits", newDebits);
                                    }}
                                  />
                                </Grid.Column>
                                <Grid.Column mobile={3} computer={2}>
                                  <MyTextInput
                                    disabled
                                    name={`debit-label-${index}`}
                                    value="Debit"
                                  />
                                </Grid.Column>
                                <Grid.Column mobile={4} computer={3}>
                                  <MyTextInput
                                    name={`debits[${index}].reason`}
                                    placeholder="Debit reason..."
                                  />
                                </Grid.Column>
                                <Grid.Column mobile={3} computer={3}>
                                  {/* Empty for alignment */}
                                </Grid.Column>
                                <Grid.Column mobile={3} computer={2}>
                                  <MyTextInput
                                    name={`debits[${index}].amount`}
                                    placeholder="0.00"
                                  />
                                </Grid.Column>
                                <Grid.Column mobile={2} computer={2}>
                                  <div className="field">
                                    <input
                                      type="text"
                                      disabled
                                      value={currencyFormatter.format(
                                        runningBalance,
                                      )}
                                      style={{ backgroundColor: "#f9fafb" }}
                                    />
                                  </div>
                                </Grid.Column>
                              </Grid.Row>
                            );
                          })}
                        </Grid>
                      )}

                      {/* Add Credit/Debit Buttons */}
                      <Grid stackable style={{ marginTop: "0em" }}>
                        <Grid.Row>
                          {/* <Grid.Column computer={8}>
                            <Button
                              type="button"
                              color="green"
                              size="small"
                              icon="plus"
                              content="Add Credit Line"
                              onClick={() => {
                                const newCredits = [
                                  ...(values.credits || []),
                                  { to: "", paidBy: "", amount: "" },
                                ];
                                setFieldValue("credits", newCredits);
                              }}
                            />
                          </Grid.Column> */}
                          {/* <Grid.Column computer={8}>
                            <Button
                              type="button"
                              color="orange"
                              size="small"
                              icon="plus"
                              content="Add Debit Line"
                              onClick={() => {
                                const newDebits = [
                                  ...(values.debits || []),
                                  { reason: "", amount: "" },
                                ];
                                setFieldValue("debits", newDebits);
                              }}
                            />
                          </Grid.Column> */}
                        </Grid.Row>
                      </Grid>

                      {/* Balance After Credit/Debit Summary */}
                      {/* <Segment color="blue" style={{ marginTop: "1em" }}>
                        <Grid>
                          <Grid.Row>
                            <Grid.Column width={10}>
                              <Header as="h4" color="blue">
                                Remaining Compensation (After Credit/Debit):
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={6} textAlign="right">
                              <Header as="h3" color="green">
                                {currencyFormatter.format(
                                  getBalanceAfterCreditDebit(
                                    values,
                                    getAsNumber(
                                      values?.financials?.compensationPayAmount,
                                    ),
                                  ),
                                )}
                              </Header>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Segment> */}

                      {/* Referral Section */}
                      <Divider />
                      <Header color="blue">Referral</Header>
                      <Grid stackable>{getTableHeader()}</Grid>
                      <Grid stackable>
                        <Grid.Row className="zero top padding">
                          <Grid.Column mobile={16} computer={colSize.one}>
                            <MyTextInput
                              disabled
                              name={"REFERRAL"}
                              value="Referral"
                            ></MyTextInput>
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.two}>
                            <MyTextInput name={"financials.referralPayName"} />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.three}>
                            <MyTextInput name={"fees.feeReferralFeePercent"} />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.four}>
                            <MyTextInput
                              name={"financials.ReferralPayAmount"}
                            />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.five}>
                            <MyTextInput disabled name={"balance.Referral"} />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>

                      {/* {brokerageDetails?.hasOtherTop && (
                        <>
                          <Header color="blue">Payout To Other </Header>
                          <Grid stackable>{getTableHeader()}</Grid>
                          <Grid stackable>
                            <Grid.Row className="zero top padding">
                              <Grid.Column mobile={16} computer={colSize.one}>
                                <MyTextInput
                                  disabled
                                  name={"OTHERTOP"}
                                  value="Other"
                                ></MyTextInput>
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.two}>
                                <MyTextInput name={"financials.otherPayName"} />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.three}>
                                <MyTextInput
                                  name={"fees.feeOtherSideFeePercent"}
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.four}>
                                <MyTextInput
                                  name={"financials.OtherSidePayAmount"}
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.five}>
                                <MyTextInput
                                  disabled
                                  name={"balance.OtherSide"}
                                />
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </>
                      )} */}

                      <Divider />
                      {transaction?.coAgent ? (
                        <>
                          <Header color="blue">Co-Agent</Header>
                          <Grid>
                            {getTableHeader()}
                            <Grid.Row className="zero top padding">
                              <Grid.Column mobile={16} computer={colSize.one}>
                                <MyTextInput
                                  disabled
                                  name={"COAGENT"}
                                  value="Co-Agent"
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.two}>
                                {/* <MyTextInput
                                  name={"financials.coAgentPayToName"}
                                /> */}
                                Total Split amount:
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.three}>
                                <MyTextInput
                                  name={"fees.feeCoAgentFeePercent"}
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.four}>
                                <MyTextInput
                                  name={"financials.CoAgentPayAmount"}
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.five}>
                                <MyTextInput
                                  disabled
                                  name={"balance.CoAgent"}
                                />
                              </Grid.Column>
                            </Grid.Row>
                            <Divider horizontal className="zero padding">
                              <Header as="h5">
                                {/* <Icon name="th list" /> */}
                                Co-Agent Fee Details
                              </Header>
                            </Divider>{" "}
                                                        {getTableHeader()}

                            <Grid.Row className="zero padding"  style={{ backgroundColor: '#f0f0f0' }}>
                              <Grid.Column mobile={16} computer={colSize.one}>
                                Co-Agent
                                <br />
                                {transaction?.coAgent?.firstName}{" "}
                                {transaction?.coAgent?.lastName}
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.two}>
                                <MyTextInput
                                  name={"financials.coAgentPayToName"}
                                  placeholder="Co-Agent Name"
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.three}>
                                <MyTextInput
                                  name={"fees.feeCoAgentPayToFeePercent"}
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.four}>
                                <MyTextInput
                                  name={"financials.CoAgentPayToPayAmount"}
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.five}>
                                {/* <MyTextInput
                                  disabled
                                  name={"balance.CoAgent"}
                                /> */}
                              </Grid.Column>
                            </Grid.Row>
                            <Grid.Row className="zero padding" style={{ backgroundColor: '#f0f0f0' }}>
                              <Grid.Column mobile={16} computer={colSize.one}>
                                <MyTextInput
                                  disabled
                                  name={"BROKERAGECOAGENT"}
                                  value="Brokerage"
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.two}>
                                <MyTextInput
                                  name={"financials.coAgentPayToBrokerageName"}
                                  placeholder="Co-Agent Brokerage"
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.three}>
                                <MyTextInput
                                  disabled
                                  name={
                                    "fees.feeCoAgentBrokeragePayToFeePercent"
                                  }
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.four}>
                                <MyTextInput
                                  name={"financials.CoAgentBrokeragePayAmount"}
                                />
                              </Grid.Column>
                              <Grid.Column mobile={16} computer={colSize.five}>
                                {/* <MyTextInput
                                  disabled
                                  name={"balance.CoAgent"}
                                /> */}
                              </Grid.Column>
                            </Grid.Row>
                            {isCoAgentOneOfMyAgents &&
                              brokerageDetails?.hasManagerFee && (
                                <Grid.Row className="zero padding">
                                  <Grid.Column
                                    mobile={16}
                                    computer={colSize.one}
                                  >
                                    <MyTextInput
                                      disabled
                                      name={"MANAGERCOAGENT"}
                                      value="Manager"
                                    />
                                  </Grid.Column>
                                  <Grid.Column
                                    mobile={16}
                                    computer={colSize.two}
                                  >
                                    <MyTextInput
                                      name={"financials.coAgentManagerPayName"}
                                      placeholder="CoAgent Manager"
                                    />
                                  </Grid.Column>
                                  <Grid.Column
                                    mobile={16}
                                    computer={colSize.three}
                                  >
                                    <MyTextInput
                                      name={"fees.coAgentFeeManagerFeePercent"}
                                    />
                                  </Grid.Column>
                                  <Grid.Column
                                    mobile={16}
                                    computer={colSize.four}
                                  >
                                    <MyTextInput
                                      name={
                                        "financials.coAgentManagerPayAmount"
                                      }
                                    ></MyTextInput>
                                  </Grid.Column>
                                  <Grid.Column
                                    mobile={16}
                                    computer={colSize.five}
                                  ></Grid.Column>
                                </Grid.Row>
                              )}
                            {isCoAgentOneOfMyAgents &&
                              currentUserProfile?.brokerage?.hasDonationFee && (
                                <Grid.Row className="zero padding">
                                  <Grid.Column
                                    mobile={16}
                                    computer={colSize.one}
                                  >
                                    <MyTextInput
                                      disabled
                                      name={"DONATIONCOAGENT"}
                                      value="Donation"
                                    />
                                  </Grid.Column>
                                  <Grid.Column
                                    mobile={16}
                                    computer={colSize.two}
                                  >
                                    <MyTextInput
                                      name={"financials.coAgentDonationPayName"}
                                    />
                                  </Grid.Column>
                                  <Grid.Column
                                    mobile={16}
                                    computer={colSize.three}
                                  >
                                    <MyTextInput
                                      name={"fees.coAgentFeeDonationFeePercent"}
                                    />
                                  </Grid.Column>
                                  <Grid.Column
                                    mobile={16}
                                    computer={colSize.four}
                                  >
                                    <MyTextInput
                                      name={
                                        "financials.coAgentDonationPayAmount"
                                      }
                                    ></MyTextInput>
                                  </Grid.Column>
                                  <Grid.Column
                                    mobile={16}
                                    computer={colSize.five}
                                  >
                                    {/* <MyTextInput name={"balance.Donation"} /> */}
                                  </Grid.Column>
                                </Grid.Row>
                              )}
                            {isCoAgentOneOfMyAgents && (
                              <Grid.Row>
                                <Grid.Column
                                  mobile={16}
                                  computer={6}
                                ></Grid.Column>

                                <Grid.Column mobile={16} computer={5}>
                                  Total payable to Co-Agent:
                                </Grid.Column>

                                <Grid.Column mobile={16} computer={3}>
                                  {currencyFormatter.format(
                                    getPayToCoAgent(values),
                                  )}
                                </Grid.Column>
                              </Grid.Row>
                            )}
                          </Grid>
                        </>
                      ) : (
                        <>
                          <Header color="blue">
                            Co-Agent{" "}
                            <Popup
                              trigger={
                                <Icon
                                  name="info circle"
                                  color="blue"
                                  size="small"
                                />
                              }
                              content="There is no Co-Agent in Parties for this transaction"
                              position="right center"
                            />
                          </Header>
                        </>
                      )}

                      <Divider />
                      <Header color="blue">Agent</Header>

                      <Grid stackable>
                        {getTableHeader()}
                        <Grid.Row className="zero padding" style={{ backgroundColor: '#f0f0f0' }}>
                          <Grid.Column mobile={16} computer={colSize.one}>
                            Agent Split
                            <br />
                            {values?.fees?.agentFullName}
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.two}>
                            <MyTextInput
                              name={"financials.agentPayToName"}
                              placeholder="Agent Pay To Name"
                            />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.three}>
                            <MyTextInput name={"fees.feeAgentFeePercent"} />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.four}>
                            <MyTextInput name={"financials.AgentPayAmount"} />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.five}>
                            <MyTextInput disabled name={"balance.Agent"} />
                          </Grid.Column>
                        </Grid.Row>
                     
                        <Grid.Row className="zero padding" style={{ backgroundColor: '#f0f0f0' }}>
                          <Grid.Column mobile={16} computer={colSize.one}>
                            <MyTextInput
                              disabled
                              name={"BROKERAGE"}
                              value={"Brokerage"}
                            ></MyTextInput>
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.two}>
                            <MyTextInput name={"financials.brokeragePayName"} />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.three}>
                            <MyTextInput
                              disabled
                              name={"fees.feeBrokerageFeePercent"}
                            />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.four}>
                            <MyTextInput
                              name={"financials.BrokeragePayAmount"}
                            />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={colSize.five}>
                            <MyTextInput
                              disabled
                              hidden
                              name={"balance.Brokerage"}
                            />
                          </Grid.Column>
                        </Grid.Row>
                           <Divider horizontal>
                          <Header as="h5">
                            {/* <Icon name="th list" /> */}
                            Agent Fees
                          </Header>
                        </Divider>{" "}
                        {/* {brokerageDetails?.hasFranchiseFee && (
                          <Grid.Row className="zero top padding">
                            <Grid.Column mobile={16} computer={colSize.one}>
                              <MyTextInput
                                disabled
                                name={"FRANCHISE"}
                                value="Franchise"
                              />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.two}>
                              <MyTextInput
                                name={"fees.feeFranchisePayName"}
                              />
                          
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.three}>
                              <MyTextInput
                                name={"fees.feeFranchiseFeePercent"}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        )} */}
                        {transaction?.tcId && (
                          <Grid.Row className="zero padding">
                            <Grid.Column mobile={16} computer={colSize.one}>
                              <MyTextInput disabled name={"TC"} value="TC" />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.two}>
                              <MyTextInput name={"financials.tcPayName"} />
                            </Grid.Column>
                            <Grid.Column
                              mobile={16}
                              computer={colSize.three}
                            ></Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.four}>
                              <MyTextInput
                                name={"financials.TcPayAmount"}
                              ></MyTextInput>
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.five}>
                              <MyTextInput
                                disabled
                                hidden
                                name={"balance.Tc"}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        )}
                        {brokerageDetails?.hasManagerFee && (
                          <Grid.Row className="zero padding">
                            <Grid.Column mobile={16} computer={colSize.one}>
                              <MyTextInput
                                disabled
                                name={"MANAGER"}
                                value="Manager"
                              />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.two}>
                              <MyTextInput name={"financials.managerPayName"} />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.three}>
                              <MyTextInput name={"fees.feeManagerFeePercent"} />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.four}>
                              <MyTextInput
                                name={"financials.ManagerPayAmount"}
                              ></MyTextInput>
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.five}>
                              <MyTextInput
                                disabled
                                hidden
                                name={"balance.Manager"}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        )}
                        {brokerageDetails?.hasDonationFee && (
                          <Grid.Row className="zero top padding">
                            <Grid.Column mobile={16} computer={colSize.one}>
                              <MyTextInput
                                disabled
                                name={"DONATION"}
                                value="Donation"
                              />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.two}>
                              <MyTextInput
                                name={"financials.donationPayName"}
                              />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.three}>
                              <MyTextInput
                                name={"fees.feeDonationFeePercent"}
                              />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.four}>
                              <MyTextInput
                                name={"financials.DonationPayAmount"}
                              ></MyTextInput>
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.five}>
                              <MyTextInput
                                disabled
                                hidden
                                name={"balance.Donation"}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        )}
                        {brokerageDetails?.hasTransactionFee && (
                          <Grid.Row className="zero top padding">
                            <Divider />

                            <Grid.Column mobile={16} computer={colSize.one}>
                              <MyTextInput
                                disabled
                                name={"TRANSACTION"}
                                value="Transaction"
                                label=" "
                              />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.two}>
                              <MySelectInput
                                name={"fees.feeTransactionWhoPays"}
                                placeholder="Who pays?"
                                label="Paid By"
                                options={[
                                  {
                                    key: "",
                                    text: "",
                                    value: "",
                                  },
                                  {
                                    key: "agent",
                                    text: "agent",
                                    value: "agent",
                                  },
                                  {
                                    key: "client",
                                    text: "client",
                                    value: "client",
                                  },

                                  {
                                    key: "other",
                                    text: "other",
                                    value: "other",
                                  },
                                ]}
                              ></MySelectInput>
                            </Grid.Column>
                            <Grid.Column
                              mobile={16}
                              computer={colSize.three}
                            ></Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.four}>
                              <MyTextInput
                                name={"fees.feeTransactionFeeAmount"}
                              />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.five}>
                              {/* <MyTextInput
                                name={"financials.TransactionPayAmount"}
                              ></MyTextInput> */}
                            </Grid.Column>
                          </Grid.Row>
                        )}
                        {values?.fees?.additionalFees?.map((fee, index) => (
                          <Grid.Row
                            key={fee.id || `additional-fee-${index}`}
                            className="zero top padding"
                          >
                            <Grid.Column mobile={16} computer={colSize.one}>
                              <MyTextInput
                                disabled
                                name={`ADDITIONALFEE${index}`}
                                value={fee.name || "Additional Fee"}
                              />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.two}>
                              <MyTextInput
                                disabled
                                name={`fees.additionalFees.${index}.payTo`}
                              />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.three}>
                              <MyTextInput
                                disabled
                                name={`fees.additionalFees.${index}.feeAmountPercent`}
                                value={
                                  fee.feeType === "percent" ? fee.feeAmount || "" : ""
                                }
                              />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.four}>
                              <MyTextInput
                                disabled
                                name={`fees.additionalFees.${index}.feeAmountDollars`}
                                value={
                                  fee.feeType === "dollars" ? fee.feeAmount || "" : ""
                                }
                              />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={colSize.five}>
                              <MyTextInput
                                disabled
                                name={`fees.additionalFees.${index}.paidBy`}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        ))}
                      </Grid>
                      <Divider />
                      <Grid stackable>
                        <Grid.Row>
                          <Grid.Column mobile={16} computer={3}>
                            <MyTextInput
                              disabled
                              label=" "
                              name={"CREDIT"}
                              value="Credit"
                            />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={5}>
                            <MySelectInput
                              name={"fees.creditGoesTo"}
                              placeholder="Who gets credit?"
                              label="Credit To"
                              options={[
                                {
                                  key: "",
                                  text: "",
                                  value: "",
                                },
                                {
                                  key: "agent",
                                  text: "agent",
                                  value: "agent",
                                },
                                {
                                  key: "client",
                                  text: "client",
                                  value: "client",
                                },
                              ]}
                            ></MySelectInput>
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={5}>
                            <MySelectInput
                              name={"fees.creditPaidBy"}
                              placeholder="Who pays credit?"
                              label="Paid By"
                              options={[
                                {
                                  key: "",
                                  text: "",
                                  value: "",
                                },
                                {
                                  key: "agent",
                                  text: "agent",
                                  value: "agent",
                                },
                                {
                                  key: "brokerage",
                                  text: "brokerage",
                                  value: "brokerage",
                                },

                                {
                                  key: "client",
                                  text: "client",
                                  value: "client",
                                },
                              ]}
                            ></MySelectInput>
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={3}>
                            <MyTextInput
                              name={"fees.creditAmount"}
                              label="$ Credit Amount"
                            />
                          </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                          <Grid.Column mobile={16} computer={colSize.one}>
                            <MyTextInput
                              disabled
                              name={"DEBIT"}
                              value="Debit"
                            />
                          </Grid.Column>
                          <Grid.Column mobile={16} computer={10}>
                            <MyTextInput
                              name={"fees.debitReason"}
                              label="Debit Reason"
                            ></MyTextInput>{" "}
                          </Grid.Column>

                          <Grid.Column mobile={16} computer={colSize.five}>
                            <MyTextInput
                              name={"fees.debitAmount"}
                              label="$ Debit Amount"
                            ></MyTextInput>
                          </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                          <Grid.Column mobile={16} computer={6}></Grid.Column>

                          <Grid.Column mobile={16} computer={5}>
                            Total payable to Agent:
                          </Grid.Column>

                          <Grid.Column mobile={16} computer={3}>
                            {currencyFormatter.format(getPayToAgent(values))}
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>

                      <Divider />
                      <Header color="blue">Distribution Authorization</Header>
                      <Grid stackable>
                        <Grid.Row>
                          <Grid.Column width={14}>
                            <>
                              Quick view of payouts:
                              <Popup
                                flowing
                                size="small"
                                trigger={
                                  <Icon
                                    name="info"
                                    color="blue"
                                    circular
                                    inverted
                                    size="small"
                                    style={{
                                      marginLeft: "3px",
                                      marginBottom: "3px",
                                    }}
                                  />
                                }
                              >
                                <p className="bold text blue mini bottom margin">
                                  Below are the payout instructions that will
                                  auto-populate in the CDA form.
                                  <br />
                                  You can still edit the CDA form inside the
                                  transaction.
                                  <br />
                                  <i>
                                    Note:Only Managers can add the CDA form to
                                    the transaction.
                                  </i>
                                </p>

                                <ol>{renderCDAListOfPayouts()}</ol>
                                {cda["text1"]?.length < 4 && (
                                  <p>
                                    Be sure the Total Compensation is filled out
                                    above,
                                    <br />
                                    and fill out at least one payout amount
                                    <br />
                                    to see the payout lines that will appear in
                                    the CDA.
                                  </p>
                                )}
                                <p></p>
                              </Popup>
                            </>
                          </Grid.Column>
                          <Grid.Column width={14}>
                            <MyTextArea
                              name="cda.specialInstructions"
                              label="Special Instructions to print on Distribution Authorization"
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                      <br />
                      <br />
                      <Button
                        loading={isSubmitting}
                        disabled={!dirty || isSubmitting}
                        type="submit"
                        floated={isMobile ? "left" : "right"}
                        primary
                        content="Create CDA"
                        className={isMobile ? "fluid large" : "large"}
                      />
                      <Button
                        onClick={() =>
                          dispatch(
                            closeModal({
                              modalType: "ManagerAgentFinancialsEditForm",
                            }),
                          )
                        }
                        type="button"
                        floated={isMobile ? null : "right"}
                        content="Close"
                        className={isMobile ? "fluid large" : "large"}
                      />
                    </Form>
                  )}
                </Formik>
              </Segment>
            </Grid.Column>
          </Grid>
        </div>
        <Divider hidden />
        <br />
      </Segment>
    </ModalWrapper>
  );
}
